import axios from 'axios'
import router from '@/router'
import md5 from 'js-md5'
// const Base64 = require('js-base64').Base64
const tokenName = 'token'
const config = {
  baseURL: '/api',
  timeout: 60 * 1000, // Timeour
  withCredentials: false // Check cross-site Access-Control
  // withCredentials: true // Check cross-site Access-Control
}
// let isTologin = 0;
const _axios = axios.create(config)
// 请求拦截器
_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (localStorage.getItem(tokenName)) {
      // config.headers.Authorization = localStorage.getItem(tokenName)
      config.headers.token = localStorage.getItem(tokenName)
    } else {
      // 打印token失效提示信息
      window.console.log('token is not exist')
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

_axios.getImg = (url, params) => {
  return _axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
    headers: {
      dataId:
        params === undefined || params === '' || params === null
          ? ''
          : md5(JSON.stringify(params)),
      jstime: new Date().getTime()
    }
  })
}

// axios响应拦截处理
_axios.interceptors.response.use(
  response => {
    //  响应成功
    switch (response.data.code) {
      case 401:
        sessionStorage.clear()

        // router.push({
        //   path: '/login'
        // })
        return Promise.resolve
      case 402:
      case 403:
        /* 登录提示*/
        // window.location.href = process.env.VUE_APP_BASE_LOGIN_URL
        break
      case 404:
        /* 路径错误提示*/
        break
      case 500:
        /* 服务器错误提示*/
        break
      case 600:
        /* token更新 */
        localStorage.setItem('token', response.data.data.token)

        // break;
        return Promise.reject('error')
      case 601:
        /* token失效 */
        localStorage.removeItem('token')
        // router.replace({path:'/'})
        // if(isTologin == 0) {
        //   console.log('失效ggggggg')
        //   router.replace({
        //     path: '/login',
        //     // query:{
        //     //   instId:Math.random()+""+Math.random()
        //     // }
        //   })
        //   isTologin = 1;
        // }

        // break;
        return Promise.reject('error')
    }
    // isTologin = 0;
    return response.data
  },
  error => {
    //  未响应 / 响应不成功
    if (error.response) {
      console.log('响应未成功')
      switch (error.response.status) {
        // 如果后台返回401 则表示token验证失败，跳回登陆界面
        case 403:
          break
        //sessionStorage.clear()
        //如果返回500，跳转到系统维护页
        case 500:
          console.log('1123132131')
          router.push({ path: '/update' })
      }
    }
    return Promise.reject(error.response.data)
  }
)
// 通过requestBody接收参数时的请求方式
_axios.postJson = (url, params) => {
  return _axios({
    method: 'post',
    url: url,
    data: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
      dataId:
        params === undefined || params === '' || params === null
          ? ''
          : md5(JSON.stringify(params)),
      jstime: new Date().getTime()
    }
  })
}
_axios.postBody = (url, params, data) => {
  return _axios({
    method: 'post',
    url: url,
    params: params,
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      dataId:
        params === undefined || params === '' || params === null
          ? ''
          : md5(JSON.stringify(params)),
      jstime: new Date().getTime()
    }
  })
}
_axios.postBodyJson = (url, params) => {
  return _axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      dataId:
        params === undefined || params === '' || params === null
          ? ''
          : md5(JSON.stringify(params)),
      jstime: new Date().getTime()
    }
  })
}
// formData接收参数时的请求方式
_axios.postForm = (url, params) => {
  return _axios({
    method: 'post',
    url: url,
    data: params,
    transformRequest: [
      function (data) {
        let ret = ''
        for (const it in data) {
          ret +=
            encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      dataId:
        params === undefined || params === '' || params === null
          ? ''
          : md5(JSON.stringify(params)),
      jstime: new Date().getTime()
    }
  })
}

_axios.get = (url, params) => {
  return _axios({
    method: 'get',
    url: url,
    params: params,
    headers: {
      dataId:
        params === undefined || params === '' || params === null
          ? ''
          : md5(JSON.stringify(params)),
      jstime: new Date().getTime()
    }
  })
}
_axios.getBody = (url, params, data) => {
  return _axios({
    method: 'get',
    url: url,
    params: params,
    data: data,
    headers: {
      dataId:
        params === undefined || params === '' || params === null
          ? ''
          : md5(JSON.stringify(params)),
      jstime: new Date().getTime()
    }
  })
}
_axios.delete = (url, params) => {
  return _axios({
    method: 'delete',
    url: url,
    params: params
  })
}
_axios.postFile = (url, params) => {
  return _axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      // 'Content-Type': "multipart/form-data;charset=UTF-8",
      enctype: 'multipart/form-data;',
      // 'dataId': params === undefined || params === '' || params === null ? '' : JSON.stringify(params),
      jstime: new Date().getTime()
    }
  })
}
_axios.download = (url, params) => {
  return _axios({
    method: 'post',
    url: url,
    data: params,
    transformRequest: [
      function (data) {
        let ret = ''
        for (const it in data) {
          ret +=
            encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob'
  })
}
export default _axios
